export default __webpack_public_path__ + "static/media/sw-1.64663abe.svg";